import { 
    apiRequest,
    koreksiKehadiranCreateAdmin,
    koreksiKehadiranApproval,
    koreksiKehadiranDinas,
    getMinDate,
    getCorrectionTypes
} from '../../../../../../services/adapters/kepegawaian/koreksiKehadiranService'

class CreateRepository {

    fetchCreate = async (query) => {
        return await apiRequest("post", koreksiKehadiranCreateAdmin, {
            body: query
        }, true)
    }

    fetchApprove = async (query) => {
        return await apiRequest("post", koreksiKehadiranApproval, {
            body: query
        }, true)
    }
    
    fetchDinas = async (query, cancelToken) => {
        return await apiRequest("get", koreksiKehadiranDinas, {
            params: query,
            cancelToken: cancelToken
        }, true)
    }

    fetchMinDate = async (query) => {
        return await apiRequest("get", getMinDate, {
            params: query
        }, true)
    }

    fetchCorrectionTypes = async (query) => {
        return await apiRequest("get", getCorrectionTypes, {
            params: query
        }, true)
    }

}

export default CreateRepository